import $ from 'jquery'

export default class Example {
  constructor ({ $container } = {}) {
    this.$container = $container

    // construction logic
    console.log('example')
  }

  // static methods
  static init () {
    const $container = $(Example.selectors.container)

    if ($container.length) {
      return new Example({ $container })
    }
  }

  // instance methods
}

// static properties here
Example.selectors = {
  container: '.js-example',
}
